import loadable from '@loadable/component';
import { MEMBERPAGES_URL } from '@lib/constants';

export const customizeCookiesPath = '/administrer-cookies';
export const CustomizeCookies = loadable(
  () => import(/* webpackChunkName: "pages-cookies-customize" */ '@pages/cookies/customize'),
  {
    resolveComponent: (m) => m.CustomizeCookies,
  },
);

export const cookieDeclarationPath = '/cookies';
export const CookieDeclaration = loadable(
  () => import(/* webpackChunkName: "pages-cookies-declaration" */ '@pages/cookies/declaration'),
  {
    resolveComponent: (m) => m.CookieDeclaration,
  },
);

export const idpReceiptPath = '/kvittering-internasjonalt-forerkort/:orderId';
export const IdpReceipt = loadable(
  () =>
    import(
      /* webpackChunkName: "pages-internationalDrivingPermit-components-Receipt-Receipt" */ '@pages/internationalDrivingPermit/components/Receipt/Receipt'
    ),
  {
    resolveComponent: (m) => m.IdpReceipt,
  },
);

export const orderReceiptPath = '/ordre-kvittering/:paymentId';
export const OrderReceipt = loadable(
  () =>
    import(
      /* webpackChunkName: "pages-MyMembership-OrderReceipt-OrderReceipt" */ '@pages/MyMembership/OrderReceipt/OrderReceipt'
    ),
  {
    resolveComponent: (m) => m.OrderReceipt,
  },
);

export const welcomePath = '/velkommen-som-medlem/:orderId';
export const Welcome = loadable(() => import(/* webpackChunkName: "pages-Welcome" */ '@pages/Welcome'), {
  resolveComponent: (m) => m.Welcome,
});

export const paymentCancelledPath = '/betaling-kansellert/:orderId';
export const PaymentCancelled = loadable(
  () => import(/* webpackChunkName: "pages-PaymentCancelled" */ '@pages/PaymentCancelled'),
  {
    resolveComponent: (m) => m.PaymentCancelled,
  },
);

export const idpArticlePath = `/internasjonalt-forerkort`;
export const IdpArticle = loadable(
  () =>
    import(
      /* webpackChunkName: "pages-internationalDrivingPermit-article-InternationalDrivingPermitArticle" */ '@pages/internationalDrivingPermit/article/InternationalDrivingPermitArticle'
    ),
  { resolveComponent: (m) => m.IdpArticle },
);

export const Chat = loadable(() => import(/* webpackChunkName: "components-Chat" */ '@components/Chat'), {
  resolveComponent: (m) => m.Chat,
});

export const becomeAMemberPath = '/bli-medlem';
export const BecomeAMember = loadable(
  () => import(/* webpackChunkName: "pages-BecomeAMember" */ '@pages/BecomeAMember'),
  {
    resolveComponent: (m) => m.BecomeAMember,
  },
);

export const buyIdpPath = '/bestill-internasjonalt-forerkort';
export const BuyInternationalDrivingPermit = loadable(
  () =>
    import(
      /* webpackChunkName: "pages-internationalDrivingPermit-InternationalDrivingPermit" */ '@pages/internationalDrivingPermit/InternationalDrivingPermit'
    ),
  { resolveComponent: (m) => m.BuyInternationalDrivingPermit },
);

export const frontPagePath = '/';
export const FrontPage = loadable(
  () => import(/* webpackChunkName: "pages-FrontPage-FrontPage" */ '@pages/FrontPage/FrontPage'),
  {
    resolveComponent: (m) => m.FrontPage,
  },
);

export const bilGuideRouterPath = '/bilguiden';
export const BilGuideRouter = loadable(
  () => import(/* webpackChunkName: "routers-BilGuideRouter" */ '../../../client/routers/BilGuideRouter'),
  {
    resolveComponent: (m) => m.BilGuideRouter,
  },
);

export const consumerTestRouterPath = '/forbrukertester/:slug';
export const ConsumerTestRouter = loadable(
  () => import(/* webpackChunkName: "routers-ConsumerTestRouter" */ '../../../client/routers/ConsumerTestRouter'),
  {
    resolveComponent: (m) => m.ConsumerTestRouter,
  },
);

export const articleTestPagePath = '/testartikkel';
export const ArticleTestPage = loadable(
  () =>
    import(/* webpackChunkName: "pages-ArticleTestPage-ArticleTestPage" */ '@pages/ArticleTestPage/ArticleTestPage'),
);

export const loggingInPath = '/nafid/login';
export const LoggingIn = loadable(
  () => import(/* webpackChunkName: "pages-LoggingIn-LoggingIn" */ '@pages/LoggingIn/LoggingIn'),
  {
    resolveComponent: (m) => m.LoggingIn,
  },
);

export const loggedOutPath = '/nafid/logout';
export const LoggedOut = loadable(
  () => import(/* webpackChunkName: "pages-LoggedOut-LoggedOut" */ '@pages/LoggedOut/LoggedOut'),
  {
    resolveComponent: (m) => m.LoggedOut,
  },
);

export const internalServerErrorPath = '/500';
export const InternalServerError = loadable(
  () =>
    import(
      /* webpackChunkName: "pages-errors-InternalServerError-InternalServerError" */ '@pages/errors/InternalServerError/InternalServerError'
    ),
  {
    resolveComponent: (m) => m.InternalServerError,
  },
);

export const myProfileRouterPath = `/${MEMBERPAGES_URL}`;
export const MyProfileRouter = loadable(
  () => import(/* webpackChunkName: "routers-MyProfileRouter" */ '../../../client/routers/MyProfileRouter'),
  {
    resolveComponent: (m) => m.MyProfileRouter,
  },
);

export const qrLandingPagePath = '/qr/:qrId';
export const QrLandingPage = loadable(
  () => import(/* webpackChunkName: "pages-QrLandingPage-QrLandingPage" */ '@pages/QrLandingPage/QrLandingPage'),
  {
    resolveComponent: (m) => m.QrLandingPage,
  },
);

export const loginPath = '/naf/auth';
export const Login = loadable(() => import(/* webpackChunkName: "pages-Login-Login" */ '@pages/Login/Login'), {
  resolveComponent: (m) => m.Login,
});
